const DataFeatures = [
  {
    id: 1,
    image: './images/features1.png',
    title: 'Найкраща якість',
    paragraph: 'У нас найкраща якість має чудовий смак!',
  },
  {
    id: 2,
    image: './images/features2.png',
    title: 'Завжди вчасно',
    paragraph: 'Наші страви завжди гарно подаються!',
  },
  {
    id: 3,
    image: './images/features3.png',
    title: 'Шеф-кухарі',
    paragraph: 'Наші кухарі - справжні художники смаку!',
  },
  {
    id: 4,
    image: './images/features4.png',
    title: 'Чудова їжа',
    paragraph: 'Їсти з нами - одне задоволення!',
  },
];

export default DataFeatures;
